import { Navigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import TeacherDetail from "../pages/teacher-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/teacher/demo" replace />,
  },
  {
    path: "/teacher/:id",
    element: <TeacherDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;